




































import Vue from "vue";
import _ from "lodash";
import { enumI18nFormat } from "@/utils/lang";
import { datetimeFormat } from "@/utils/lang";

export default Vue.extend({
    name: "MyClassCard",
    props: {
        certificate: {
            type: Object,
            required: true
        },
        index: Number
    },
    data() {
        return {
            defaultImage: require("@/assets/plan-default-cover.png")
        };
    },
    computed: {
        certificateTemplateTypeText(): string {
            return enumI18nFormat("certificateTemplateTypeEnum", this.certificate.certificateTemplateType) as string;
        },
        klassNamesText(): string {
            return _.join(this.certificate.klassNames, ",");
        },
        awardDateText(): string {
            return datetimeFormat(this.certificate.awardDate, this.$constants.DATE_FMT);
        }
    },
    methods: {
        preview() {
            this.$emit("preview", this.index);
        }
    }
});
